import React, { Component } from 'react';
import config from './../../config';
import {
  AcceptTermsCheck,
  ArticlesLink,
  CheckWrapper,
  Subscribe,
  SubscribeAcceptTermsContainer,
  SubscribeBackground,
  SubscribeBodyText,
  SubscribeCaliforniaResidentContainer,
  SubscribeEmailField,
  SubscribeSignup,
  SubscribeSubmitButton,
  SubscribeThankyou,
  SubscribeThankyouText,
  SubscribeTitle,
  SubscribeValidation,
  StyledDisclaimer,
} from './SubscribeToDaily.styled';
import verifyEmail from '../../helpers/VerifyEmail';
import Cookies from 'js-cookie';

class SubscribeToDaily extends Component<
  {
    // props
    acceptTerms: boolean;
    submitText: string;
    bodyText: string;
    inputPlaceholderText: string;
  },
  {
    // state
    checked: boolean;
    caChecked: boolean;
    fieldValue: string;
    submitted: boolean;
    displayEmailError: boolean;
    displayPolicyError: boolean;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      checked: false,
      caChecked: false,
      fieldValue: '',
      submitted: false,
      displayEmailError: false,
      displayPolicyError: false,
    };
  }

  public componentDidMount() {
    const { acceptTerms } = this.props;
    this.setState({ checked: acceptTerms });
  }

  public handleChecked = () => {
    const { checked } = this.state;
    this.setState({ checked: !checked });
  };

  public handleCaChecked = () => {
    const { caChecked } = this.state;
    this.setState({ caChecked: !caChecked });
  };

  public handleSubmit = async (event: any) => {
    event.preventDefault();
    this.setState({ displayEmailError: false });
    this.setState({ displayPolicyError: false });
    const { checked, caChecked, fieldValue } = this.state;
    if (checked && verifyEmail(fieldValue)) {
      this.setState({ submitted: true });
      try {
        const response = await fetch(`${config.salesForceProxyApiUrl}/leadcreationservice`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add any other headers as needed
          },
          body: JSON.stringify({
            Email: fieldValue,
            ExtranetId: Cookies.get('em_extid') || null,
            CurrentUrl: document.location.href,
            State: caChecked ? 'California' : null,
            ReferringUrl: document.referrer || null,
            FormId: config.edailyNewsletterFormId,
          }),
        });
        if (!response.ok) {
          // Handle non-successful response (e.g., server error)
          console.error('Error:', response.statusText);
          return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'gtm.newsletterSubmitSuccess',
          newsletterName: 'eMarketer Daily', // DO NOT MODIFY TO EMARKETER AS THIS WILL BE CONSIDERED A NEW EVENT
        });

        // const responseData = await response.json(); available response from Salesforce, not needed at this time
      } catch (error: any) {
        // Handle network or other errors
        console.error('Error:', error.message);
      }
      return false;
    } else if (!verifyEmail(fieldValue)) {
      this.setState({ displayEmailError: true });
    } else if (!checked) {
      this.setState({ displayPolicyError: true });
    }
  };

  public render() {
    const { bodyText, submitText, inputPlaceholderText } = this.props;
    const { submitted, displayEmailError, displayPolicyError, checked, caChecked } = this.state;
    const visibilityStyles = () => {
      return submitted ? 'swap' : '';
    };
    const formValidationStyle = () => {
      return displayPolicyError ? 'error' : '';
    };

    const termsAnchor = (
      <a className="subscribe__terms" href={config.ctaTermsUrl} data-analytics="Forecasts-SubscribeToDaily-TermsUrl">
        Terms of Service
      </a>
    );
    const privacyAnchor = (
      <a
        className="subscribe__terms"
        href={config.ctaPrivacyUrl}
        data-analytics="Forecasts-SubscribeToDaily-PrivacyUrl"
      >
        Privacy Policy
      </a>
    );
    const disclosureText = (
      <>
        By clicking “Sign Up”, you agree to receive emails from EMARKETER (e.g. FYIs, partner content, webinars, and
        other offers) and accept our {termsAnchor} and {privacyAnchor}. You can opt-out at any time.
      </>
    );
    return (
      <Subscribe id="subscribeToDailyNewsletter">
        <SubscribeBackground>
          <img
            width="446"
            height="216"
            src={`${config.baseName}/images/forecasts_landing_desktop_map-min.png`}
            alt="Sign up for the EMARKETER Daily, our free newsletter."
          />
        </SubscribeBackground>
        <SubscribeSignup className={`${visibilityStyles()}`}>
          <SubscribeTitle>
            Want more <span style={{ color: 'red' }}>marketing</span> insights?
          </SubscribeTitle>
          <SubscribeBodyText>{bodyText}</SubscribeBodyText>
          <form action="" onSubmit={this.handleSubmit} id="Dashboards-NewsletterSignup-Form">
            <SubscribeEmailField
              type="text"
              placeholder={inputPlaceholderText}
              // tslint:disable-next-line: jsx-no-lambda
              onChange={(e) => this.setState({ fieldValue: e.target.value })}
              data-analytics="Dashboards-NewsletterSignup-Email"
            />
            <SubscribeSubmitButton
              type="submit"
              value={submitText}
              data-analytics="Forecasts-Home-CTA-Newsletter-Submit"
            />
            <CheckWrapper>
              <SubscribeCaliforniaResidentContainer>
                <AcceptTermsCheck
                  type="checkbox"
                  name="californiaResident"
                  checked={caChecked}
                  onChange={this.handleCaChecked}
                  data-analytics="Forecasts-Home-CTA-Newsletter-CaliforniaResident"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label>California Resident</label>
              </SubscribeCaliforniaResidentContainer>
              <SubscribeAcceptTermsContainer className={`${formValidationStyle()}`}>
                <AcceptTermsCheck
                  type="checkbox"
                  name="acceptTerms"
                  checked={checked}
                  onChange={this.handleChecked}
                  data-analytics="Forecasts-Home-CTA-Newsletter-AcceptTerms"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label>I agree to the terms of service and privacy policy.</label>
              </SubscribeAcceptTermsContainer>
            </CheckWrapper>
            {displayEmailError ? (
              <SubscribeValidation>
                <br />
                Please enter a valid email address
              </SubscribeValidation>
            ) : null}
            {displayPolicyError ? (
              <SubscribeValidation>
                <br />
                Please make the necessary selection
              </SubscribeValidation>
            ) : null}
          </form>
          <StyledDisclaimer>{disclosureText}</StyledDisclaimer>
        </SubscribeSignup>
        <SubscribeThankyou className={`${visibilityStyles()}`}>
          <SubscribeThankyouText>Thanks for signing up for our newsletter!</SubscribeThankyouText>
          <ArticlesLink href={`${config.articlesServiceUrl}`}>
            You can read recent articles from EMARKETER here.
          </ArticlesLink>
        </SubscribeThankyou>
      </Subscribe>
    );
  }
}

export default SubscribeToDaily;
